import { getCredits } from '@/requests/monetization/getCredits';

type CheckCreditsParams = {
  projectCreditsCount: number | null;
};

type CheckCreditsResult = {
  isCreditsEnough: boolean;
};

const checkCredits = async ({
  projectCreditsCount,
}: CheckCreditsParams): Promise<CheckCreditsResult> => {
  const allCredits = await getCredits();

  const requiredCredits = projectCreditsCount ?? 0;
  const isCreditsEnough = allCredits >= requiredCredits;

  return { isCreditsEnough };
};

export { checkCredits };
